// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect x="5" y="6.5" width="14" height="11" fill={props.color} />
			<path d="M20.5 5H3.5V17.5H0.5V21H23.5V17.5H20.5V5Z" stroke={props.color} />
		</svg>
	</>
);

export default Icon;
